Lyte.Component.register("lyte-layout-row", {
	data : function(){
		return {
			'ltPropColarray' : Lyte.attr('array',{'default':[]}),
			'ltPropDivision' : Lyte.attr('array'),
			'sum' : Lyte.attr('number',{'default':0}),
			'ltPropColsize' : Lyte.attr('string',{'default':'fluid'}),
			'ltPropDivsize' : Lyte.attr('object',{'default':{'fluid':'col','small':'smcol','medium':'mdcol','large':'lgcol','xlarge':'xlcol','default':'col'}})
		}		
	}


});